import React, {useState} from "react";
import {Dropdown, Alert, Button} from 'react-bootstrap';
import {Box, Container, Row, Column, FooterLink, Heading, Address, SocialMediaBlock} from "./FooterStyles";
import useBackend, {LogOff, UserData} from '../services/useBackend';
import { FaSms, FaSignOutAlt, FaKey, FaUser, FaCog } from 'react-icons/fa';
import './Menu.css';

const Top = () => {

  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const {IsLoggedIn, token}      = UserData();

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

	return (
		<Box>
		<Container>

    <nav className="navbar navbar-expand-lg navbar-dark ">
      <a className="navbar-brand" href="/">Demo</a>
      <button className="custom-toggler navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample09" aria-controls="navbarsExample09" aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
        <span className="navbar-toggler-icon"></span>
      </button>
                
      <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarsExample09">
        <ul className="navbar-nav">

            {IsLoggedIn ? ( 
              <>
                <a style={{color:"white"}} className="nav-item nav-link active" href={process.env.PUBLIC_URL+"/"}>Hem</a>          
                <a style={{color:"white"}} className="nav-item nav-link active" href={process.env.PUBLIC_URL+"/cities"}>Städer</a>             
              </>
              ) :(
              <>
                <a style={{color:"white"}} className="nav-item nav-link active" href={process.env.PUBLIC_URL+"/"}>Hem</a>
                <a style={{color:"white"}} className="nav-item nav-link active" href={process.env.PUBLIC_URL+"/contact"}>Kontakt</a>       
              </>                  
            )}

        </ul>
        <ul className="navbar-nav ms-auto">
          {IsLoggedIn && isNavCollapsed && (
            <>
              <div className="dropdown nav-link">
                  <a style={{color:"white"}} href="#" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">{token.name}</a>
                  <div className="dropdown-menu dropdown">                            
                      <a href={process.env.PUBLIC_URL+"/mypage"} className="dropdown-item"><FaCog/>&nbsp;Min Profil</a>
                      <a href={process.env.PUBLIC_URL+"/password/change"} className="dropdown-item"><FaKey/>&nbsp;Byt lösenord</a>
                      <a className="dropdown-item" onClick={LogOff}><FaSignOutAlt/>&nbsp;Logga ut</a>
                  </div>
              </div>                    
            </>)
          }

          {IsLoggedIn && !isNavCollapsed && (
            <>      
              <hr style={{color:"white", padding:"2px"}}></hr>
              <div style={{color:"white", padding:"2px"}}>{token.name}</div>
              <div>
                <a style={{color:"white", marginRight:"12px"}} className="nav-item nav-link_ active"  onClick={LogOff}><FaSignOutAlt/>&nbsp;Logga ut</a>
                
                <a style={{color:"white", marginRight:"12px"}} className="nav-item nav-link_ active" href={process.env.PUBLIC_URL+"/password/change"} ><FaKey/>&nbsp;Byt lösenord</a>
                
                <a style={{color:"white", marginRight:"12px"}} className="nav-item nav-link_ active" href={process.env.PUBLIC_URL+"/mypage"} ><FaCog/>&nbsp;Min Profil</a>
              </div>
            </>) 
          }                    

          {!IsLoggedIn && (<><Button className="CloudLoginButton" variant="primary" href="/login">Logga in</Button></>)}  
          
        </ul>      
      </div>
    </nav>    

		</Container>
		</Box>
	);
};

export default Top;